module.exports = __webpack_public_path__ + "img/logo.993ceb7c.png";